// extracted by mini-css-extract-plugin
module.exports = {"blockBtn":"Admins_blockBtn__OzSnD","createAdminBtn":"Admins_createAdminBtn__2Y_M4"};